/** The sections of Nastavení kanceláře the caller may open, in menu order. */
import { useMasterPermissions } from '@/features/auth';
import { canOpenMasterAccountBoardSection } from '../utils/master-account-board-home';
import {
  MASTER_ACCOUNT_SETTINGS_SECTIONS,
  type MasterAccountSettingsSectionId
} from '../utils/master-account-settings-sections';
import { useOfficeBridgesMenuState } from './use-office-bridges-menu';
import { useOfficeIntegrationTemplatesMenuState } from './use-office-integration-templates-menu';

export interface MasterAccountSettingsSectionsState {
  readonly sections: MasterAccountSettingsSectionId[];
  /** True while the Bridge or template item may still appear. */
  readonly loading: boolean;
}

export function useMasterAccountSettingsSectionsState(): MasterAccountSettingsSectionsState {
  const { hasMasterPermission } = useMasterPermissions();
  const bridges = useOfficeBridgesMenuState();
  const templates = useOfficeIntegrationTemplatesMenuState();

  const canOpen = (id: MasterAccountSettingsSectionId): boolean => {
    switch (id) {
      case 'office':
      case 'manage':
        return canOpenMasterAccountBoardSection('office', hasMasterPermission);
      case 'people':
        return canOpenMasterAccountBoardSection('people', hasMasterPermission);
      case 'billing':
      case 'credits':
        return canOpenMasterAccountBoardSection('billing', hasMasterPermission);
      case 'bridges':
        return bridges.visible;
      case 'integrationTemplates':
        return templates.visible;
    }
  };

  return {
    sections: MASTER_ACCOUNT_SETTINGS_SECTIONS.map(section => section.id).filter(canOpen),
    loading: bridges.loading || templates.loading
  };
}

export function useMasterAccountSettingsSections(): MasterAccountSettingsSectionId[] {
  return useMasterAccountSettingsSectionsState().sections;
}
